import ScrollMagic from 'scrollmagic';
import Cases from '../../../blocks/cases/cases';

$(() => {
    const cases = new Cases('.js-cases');
    const controller = new ScrollMagic.Controller();

    new ScrollMagic.Scene({
        triggerElement: '.l-page__header',
        offset: 50,
        reverse: false
    })
    .setClassToggle('.l-page__header .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__cases-cases',
        triggerHook: 0.95,
        reverse: false
    })
    .setClassToggle('.l-page__cases-cases .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__get-now',
        triggerHook: 0.8,
        reverse: false
    })
    .setClassToggle('.l-page__get-now .js-animate', 'js-animate-loaded')
    .addTo(controller);
})



// WEBPACK FOOTER //
// ./app/scripts/pages/about/cases.js